import React from 'react'
import { View } from 'oio-react'
import PropTypes from 'prop-types'
import { LAYOUT_BOX } from 'config/constants/ui'
import { useGlobalState } from 'src/sites/state'

const MultiPageContentPane = ({ children }) => {
   const { theme } = useGlobalState()

   // TODO: This is kind of dumb and should be done more intelligently
   // PR #810
   const isFixedWidthLayout = theme.layoutContentFillMode === 'fixed'
   const isBoxGL = theme.tmpGlobalLayout === LAYOUT_BOX
   let contentOffset = '0[a-b] 32vw[c] 300px[d] 350px[e-f]'

   if (isFixedWidthLayout) {
      contentOffset = `0[a-b]
         calc(32vw + ${theme.tmpViewportPaddingC})[c]
         calc(300px + ${theme.tmpViewportPaddingD})[d]
         calc(350px + ${theme.tmpViewportPaddingE})[e]
         calc(350px + ${theme.tmpViewportPaddingF})[f]`
   } else if (isBoxGL) {
      contentOffset = `
         0[a-b]
         calc(32vw + ${theme.tmpViewportPaddingC})[c]
         330px[d]
         370px[e]
         370px[f]
      `
   }

   return (
      <View
         position="absolute"
         top="0px"
         left={contentOffset}
         right="0px"
         bottom="0px"
         style={{ overflow: 'hidden' }}>
         {children}
      </View>
   )
}

MultiPageContentPane.propTypes = {
   children: PropTypes.node.isRequired
}

export default MultiPageContentPane
